import type { MotionSkin } from "./types";

export const summerSkin: MotionSkin = {
  id: "summer",
  label: "夏",
  season: "summer",
  palette: {
    backgroundTop: "#9fdef5",
    backgroundBottom: "#fff5d6",
    foreground: "#123047",
    muted: "#48677c",
    up: "#10b981",
    down: "#f05b70",
    grid: "rgba(40,91,120,.16)",
    card: "rgba(255,255,255,.76)",
    panel: "rgba(255,255,255,.78)",
    accent: "#ffb84a"
  },
  typography: { family: "system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif", titleWeight: 800 },
  decoration: "summer",
  upEffect: "splash",
  downEffect: "squall",
  assetSlots: {
    background: "/skins/summer/background.png",
    tipIdle: "/skins/summer/tipIdle.png",
    tipUp: "/skins/summer/tipUp.png",
    tipDown: "/skins/summer/tipDown.png"
  }
};
